"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLoadMore = void 0;
const react_1 = require("react");
const hooks_1 = require("../../hooks");
const REQUEST_MAX_TRY = 3;
const useLoadMore = ({ moreItemsLoading, hasNextPage, onLoadMore, }) => {
    const observer = (0, react_1.useRef)(null);
    const errorCounter = (0, react_1.useRef)(0);
    const { addError } = (0, hooks_1.useNotification)();
    const handleLoadMore = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield onLoadMore();
            errorCounter.current = 0;
        }
        catch (error) {
            addError(error.message);
            errorCounter.current = ++errorCounter.current;
            if (errorCounter.current <= REQUEST_MAX_TRY) {
                void handleLoadMore();
            }
        }
    }), [addError, onLoadMore]);
    const lastElementRef = (0, react_1.useCallback)((node) => {
        if (observer.current) {
            observer.current.disconnect();
        }
        if (moreItemsLoading || errorCounter.current >= REQUEST_MAX_TRY) {
            return;
        }
        observer.current = new IntersectionObserver((entries) => {
            if (entries[0].isIntersecting && hasNextPage) {
                void handleLoadMore();
            }
        });
        if (node && hasNextPage) {
            observer.current.observe(node);
        }
    }, [handleLoadMore, hasNextPage, moreItemsLoading]);
    return lastElementRef;
};
exports.useLoadMore = useLoadMore;
